import React from 'react'



export default function Resume() {
  return (
    <div className='myResume'>
      <img src='/images/stevresume.jpg' alt='resume'/>
    </div>
  )
}
